// extracted by mini-css-extract-plugin
export default {"text-color-light":"#707070","textColorLight":"#707070","from":"zityp pHVUV AgyN9"};